// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:58:39.262Z
// Property: Legacy Apartments at Dove Mountain (ID: 6767906449166439)
// Collections: 24 amenities, 8 floorplans (live), 24 photos, 54 POIs, 3 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166439",
  "property_external_id": "jp69535",
  "property_zillow_url": "https://www.zillow.com/apartments/marana-az/legacy-apartments-at-dove-mountain/5XrtrT/",
  "property_apartments_url": "https://www.apartments.com/legacy-apartments-at-dove-mountain-marana-az/jp69535/",
  "property_google_business_url": "https://www.google.com/maps/place/Legacy+Apartments+at+Dove+Mountain/data=!4m2!3m1!1s0x0:0xb5f951c3ac8bfe5f?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "40239852128",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "241LDM",
  "property_status": null,
  "property_slug": "legacy-apartments-at-dove-mountain",
  "property_name": "Legacy Apartments at Dove Mountain",
  "property_website_url": "https://www.legacyapartmentsindovemountain.com/",
  "property_domain": "https://www.legacyapartmentsindovemountain.com/",
  "property_address": "12100 North Mountain Centre Road",
  "property_full_address": "12100 N Mountain Centre Rd, Marana, AZ 85658",
  "property_address_1": "12100 N Mountain Centre Rd",
  "property_address_2": null,
  "property_address_city": "Marana",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85658",
  "property_address_country": "US",
  "property_address_county": "Pima County",
  "property_neighborhood_address": "Dove Mountain",
  "property_address_latitude": "32.4272793",
  "property_address_longitude": "-111.0747293",
  "property_email": null,
  "property_phone": "(520) 616-2179",
  "property_call_tracking_phone": "844-888-1521",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Legacy Apartments at Dove Mountain, where comfort meets modern living in Marana, AZ. Choose from spacious one, two, or three-bedroom floor plans, each featuring upscale amenities like a resort-style heated swimming pool, state-of-the-art fitness center, and large private patios. Your perfect home awaits!",
  "property_long_description": "**Welcome to Legacy Apartments at Dove Mountain** – your gateway to luxurious living in the heart of Marana, AZ! Our thoughtfully designed apartment community offers an array of spacious floor plans, including one, two, and three-bedroom options, tailored to suit your lifestyle and needs. \n\nStep inside and discover modern interiors featuring ceramic-style flooring, plush carpeting, and stylish espresso cabinetry that complements your gourmet kitchen equipped with stainless steel appliances. Enjoy abundant storage with large walk-in closets and step out onto your private patio for some fresh air. Select units even include oversized countertops for the cooking enthusiast!\n\nAt Legacy Apartments, we pride ourselves on exceptional amenities that elevate your living experience. Unwind in our resort-style heated swimming pool or take a stroll to our relaxing spa with seating. For your convenience, we offer covered parking, garages*, and Amazon HUB lockers. Our state-of-the-art fitness center will help you stay on track with your fitness goals, while our professional 24-hour on-site maintenance team ensures peace of mind.\n\nOur community also features a clubhouse designed for social gatherings, complete with gas grills and a bark park for your furry friends. With controlled access gates and a property-wide fiber optic internet, you can enjoy both security and connectivity.\n\nDon’t miss your chance to make Legacy Apartments at Dove Mountain your new home! Browse our availability or schedule a tour today to experience how we blend luxury and comfort seamlessly. Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f6b9b-329b-714a-9c3d-32af67613dfa.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas at Legacy Apartments Dove Mountain.",
    "public_id": "019f6b9b-329b-714a-9c3d-32af67613dfa",
    "storage_key": "property/6767906449166439/019f6b9b-329b-714a-9c3d-32af67613dfa.webp",
    "width": 1920,
    "height": 1080
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166439/019ffc3a-2473-75fc-a557-84771536ef6e.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-2473-75fc-a557-84771536ef6e",
    "storage_key": "property/6767906449166439/019ffc3a-2473-75fc-a557-84771536ef6e.m4v",
    "thumbnail_key": "property/6767906449166439/019ffc3a-2473-75fc-a557-84771536ef6e_thumb.webp",
    "size_bytes": 21211913,
    "classification": "Community",
    "title": "Luxury Apartments with Pool, Gym, and Putting Green",
    "description": "Explore the amenities and common areas of our luxury apartments, featuring a resort-style pool, a fully equipped gym, and a putting green for residents."
  },
  "property_total_units": "168",
  "property_year_built": "2011",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.26190476190477",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply. Limit of 2 pets per home.",
  "property_pet_policy_description": "Pets welcome upon approval. Breed restrictions apply. Limit of 2 pets per home. Non‑refundable pet fee: $350 for one pet, $500 for two pets. Monthly pet rent: $35 for one pet, $50 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://legacydovemountain.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amclegacyatdovemountain",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-63cb-736d-89c6-e971ec172492.webp",
  "property_primary_logo_media": {
    "alt_text": "Legacy at Dove Mountain logo",
    "public_id": "019d02cc-63cb-736d-89c6-e971ec172492",
    "storage_key": "property/6767906449166439/019d02cc-63cb-736d-89c6-e971ec172492.webp",
    "width": 297,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-595b-774e-95cf-ff0df064f5e1.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo.",
    "public_id": "019d02cc-595b-774e-95cf-ff0df064f5e1",
    "storage_key": "property/6767906449166439/019d02cc-595b-774e-95cf-ff0df064f5e1.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-6ef4-7552-8082-c348764060d0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Legacy at Dove Mountain logo",
    "public_id": "019d02cc-6ef4-7552-8082-c348764060d0",
    "storage_key": "property/6767906449166439/019d02cc-6ef4-7552-8082-c348764060d0.webp",
    "width": 297,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-753e-775a-b2e0-5e028f581e87.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Legacy at Dove Mountain logo",
    "public_id": "019d02cc-753e-775a-b2e0-5e028f581e87",
    "storage_key": "property/6767906449166439/019d02cc-753e-775a-b2e0-5e028f581e87.webp",
    "width": 297,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "698 - 1150",
  "property_sqft_min": "698",
  "property_sqft_max": "1150",
  "property_price_range": "$1395 - $1799",
  "property_price_min": "1395",
  "property_price_max": "1799",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/LegacyAtDoveMountain",
  "property_instagram_url": "https://www.instagram.com/LegacyAtDoveMountain",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_1DTNPEJ1oYRX_6LrMNR-bU",
  "property_youtube_url": "https://www.youtube.com/watch?v=AhtdKhERxJ0",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Marana%2C+AZ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Legacy Apartments at Dove Mountain",
  "property_home_romance_title": "Embrace Your New Lifestyle, Cherish Every Moment Here",
  "property_home_amenities_blurb": "Welcome to Legacy Apartments at Dove Mountain, where comfort meets modern living in the heart of Marana, AZ. Enjoy a heated resort-style pool, relax in our soothing spa, or energize in our state-of-the-art fitness center. Experience the charm of spacious apartments with designer finishes and exclusive amenities tailored for your lifestyle.",
  "property_home_floorplans_blurb": "At Legacy Apartments at Dove Mountain, Marana’s hidden gem, each floor plan is designed for comfort and style, catering to every lifestyle. Experience breathtaking views and modern amenities that elevate your living experience. Browse our available apartment homes to discover your ideal sanctuary nestled in the serene beauty of Arizona.",
  "property_home_gallery_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, your dream lifestyle awaits. Enjoy modern amenities like a resort-style heated pool, state-of-the-art fitness center, and relaxing spa. With spacious floor plans, large walk-in closets, and private patios, picture yourself living in comfort and style. Your new home is just a click away!",
  "property_home_neighborhood_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, experience the perfect blend of comfort and convenience. Choose from one-, two-, or three-bedroom floor plans and immerse yourself in a vibrant neighborhood. Enjoy nearby parks, libraries, fitness centers, and local boutiques to enhance your lifestyle. Uncover your new community today!",
  "property_home_reviews_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, our residents rave about the vibrant community and welcoming atmosphere: “Living here feels like home!” Join a neighborhood that values comfort and connection. See what our residents have to say about living at our community, and envision your new life here!",
  "property_neighborhood_blurb": "At Legacy Apartments at Dove Mountain, vibrant living extends beyond your doorstep. Nestled in Marana, AZ, you’ll find a world of convenience with local gems like the Tucson Premium Outlets, Oro Valley Public Library, and beautiful Naranja Park. Immerse yourself in a dynamic community where every day feels like an adventure. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Legacy Apartments at Dove Mountain in Marana, AZ, where comfort meets convenience! Enjoy modern living with spacious one, two, and three-bedroom floor plans, paired with resort-style amenities like a heated swimming pool, state-of-the-art fitness center, and charming bark park. Experience a lifestyle designed just for you!",
  "property_applynow_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy amenities like a resort-style heated pool, state-of-the-art fitness center, and private patios. Experience comfort and convenience in your new home—lease online today!",
  "property_contactus_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, our thoughtfully designed floor plans include stylish one, two, and three-bedroom options to suit your lifestyle. Whether you seek cozy comfort or spacious living, we have a perfect fit for you. Reach out to our leasing team today with any inquiries!",
  "property_faqs_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, your perfect home awaits. Whether you seek a cozy one-bedroom or a spacious three-bedroom, our diverse floor plans cater to every lifestyle. Got questions? Browse our FAQs page for insights into our vibrant community and start your journey today!",
  "property_floorplans_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, find your ideal sanctuary with our thoughtfully designed one, two, and three-bedroom floor plans. Each layout perfectly balances comfort and style, ensuring every resident feels at home. Browse our available apartments today and take the first step towards your new lifestyle!",
  "property_gallery_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, each floor plan—from cozy one-bedrooms to spacious three-bedrooms—invites you to indulge in modern living. Enjoy upscale amenities like a resort-style heated pool, state-of-the-art fitness center, and a relaxing spa. Picture yourself living here, where comfort meets style!",
  "property_interactivemap_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, choose from spacious one, two, or three-bedroom floor plans that blend luxury and comfort. With amenities like a resort-style heated pool, state-of-the-art fitness center, and modern kitchens, you’ll find your ideal home. Use our interactive community map to start your journey today!",
  "property_pets_blurb": "At Legacy Apartments at Dove Mountain, embrace a lifestyle that celebrates both comfort and community in sunny Marana, AZ. With ample space for you and your furry friends—pending approval—our pet-friendly policy ensures your companions can enjoy life alongside you, making every day feel like home.",
  "property_referafriend_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, comfort meets style with thoughtfully designed floor plans, including one, two, and three-bedroom options. Great friends make great neighbors—share the Legacy experience by referring a friend to our vibrant community. Together, create lasting memories in our welcoming neighborhood!",
  "property_residentaccess_blurb": "Welcome to Legacy Apartments at Dove Mountain, Marana's premier community offering one, two, and three-bedroom floor plans tailored for your lifestyle. Access your resident portal to effortlessly manage rent payments, schedule maintenance, and connect with your neighbors. Enjoy a seamless living experience in this vibrant community!",
  "property_reviews_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, residents rave about their experience, stating, \"The sense of community and beautiful surroundings make this place feel like home.\" See what our residents have to say about living at our community and uncover the lifestyle waiting for you!",
  "property_created_at": "1759782566789",
  "property_scheduletour_blurb": "At Legacy Apartments at Dove Mountain in Marana, AZ, choose from our thoughtfully designed one, two, or three-bedroom floor plans that elevate your lifestyle. Experience luxury living complemented by stunning views and community vibes. Curious if we’re the right fit? Check out our residents' testimonials ahead of your tour!",
  "property_thankyou_blurb": "Thank you for reaching out to Legacy Apartments at Dove Mountain in Marana, AZ! Our diverse selection of floor plans—one, two, and three-bedroom options—ensures a perfect fit for your lifestyle. A team member will be in touch soon to assist you in finding your new home.",
  "property_virtualtours_blurb": "Step into the inviting world of Legacy Apartments at Dove Mountain in Marana, AZ. Choose from thoughtfully designed one, two, or three-bedroom floor plans that harmonize style and comfort. Dive into our virtual tour and experience your future home where modern living meets natural beauty!",
  "property_copyright": "2025 All Rights Reserved. Legacy Apartments at Dove Mountain",
  "property_seo_title_home": "Legacy Apartments at Dove Mountain | Marana, AZ Apartments",
  "property_seo_description_home": "Discover modern living at Legacy Apartments at Dove Mountain in Marana, AZ, near Tucson. Enjoy spacious layouts, resort-style amenities, & a vibrant community!",
  "property_seo_title_floorplans": "Floor Plans | Apartments in Marana, AZ",
  "property_seo_description_floorplans": "Find your ideal space at Legacy Apartments at Dove Mountain in Marana, AZ. Choose from one to three-bedroom floor plans tailored for comfort and style.",
  "property_seo_title_amenities": "Amenities | Luxury Apartments Marana, AZ",
  "property_seo_description_amenities": "Discover luxury at Legacy Apartments in Marana, AZ! Enjoy resort-style amenities like a swimming pool, fitness center, clubhouse, dog park, and more.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments Near Tucson, AZ",
  "property_seo_description_gallery": "Experience luxury at Legacy Apartments in Marana, AZ. With stunning floor plans and resort-style amenities, picture yourself in comfort and style here!",
  "property_seo_title_virtualtours": "Resident Access | Homes Near West Valley City UT",
  "property_seo_description_virtualtours": "Log in to Little Valley's resident portal in Magna, UT. Manage rent, schedule maintenance, and enjoy seamless living at your fingertips!",
  "property_seo_title_interactivemap": "Interactive Map | Legacy Apartments at Dove Mountain",
  "property_seo_description_interactivemap": "Discover your ideal home at Legacy Apartments in Marana, AZ! Use our interactive map to explore spacious layouts and premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Tucson, AZ",
  "property_seo_description_neighborhood": "Uncover the charm of Marana, AZ at Legacy Apartments at Dove Mountain. Live near Tucson, Dove Mountain, Century Theatre, Arizona Sonora Desert Museum, & more.",
  "property_seo_title_contact": "Contact Us | Marana Apartments | Apartments Near Tucson, AZ",
  "property_seo_description_contact": "Connect with Legacy Apartments at Dove Mountain in Marana, AZ. Inquire about our one, two, and three-bedroom floor plans today—your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Marana, AZ",
  "property_seo_description_faqs": "Get the scoop on Legacy Apartments at Dove Mountain! Unlock insights on floor plans, amenities, and living in beautiful Marana, AZ. Your questions answered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Marana, AZ",
  "property_seo_description_reviews": "Join the Legacy Apartments family in Marana, AZ! Check out resident reviews and see why our community feels like home, complete with top-notch amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Marana, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at Legacy Apartments at Dove Mountain near Tucson! Enjoy spacious 1-3 bedroom homes with luxury amenities. Apply online today!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Magna, UT",
  "property_seo_description_residentaccess": "Find your ideal home at Little Valley in Magna, UT! Enjoy spacious townhomes, modern amenities, and a pet-friendly community. Apply online today!",
  "property_seo_title_referafriend": "Refer A Friend | Legacy Apartments at Dove Mountain",
  "property_seo_description_referafriend": "Refer a friend to Legacy Apartments at Dove Mountain! Build great memories in Marana, AZ, where friendship thrives and vibrant living awaits. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Marana, AZ",
  "property_seo_description_scheduletour": "Uncover the charm of Legacy Apartments at Dove Mountain in Marana, AZ near Tucson. Schedule a tour today and envision your new oasis in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Legacy Apartments at Dove Mountain",
  "property_seo_description_privacy": "Your privacy matters at Legacy Apartments at Dove Mountain. Learn how we protect your information and ensure a secure living experience in Marana, AZ.",
  "property_seo_title_accessibility": "Accessibility | Legacy Apartments at Dove Mountain",
  "property_seo_description_accessibility": "At Legacy Apartments at Dove Mountain, we prioritize accessibility for all. Join our inclusive community in Marana, AZ, where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Legacy Apartments at Dove Mountain",
  "property_seo_description_sitemap": "Uncover every corner of Legacy Apartments at Dove Mountain in Marana, AZ. Access our sitemap for a seamless journey through your future home.",
  "property_seo_title_thankyou": "Thank You | Legacy Apartments at Dove Mountain",
  "property_seo_description_thankyou": "Thank you for reaching out! A Legacy Apartments team member will connect soon to help you find your ideal home in beautiful Dove Mountain, Marana, AZ.",
  "property_seo_title_pets": "Pets | Pet Friendly Apartments Marana, AZ",
  "property_seo_description_pets": "At Legacy Apartments at Dove Mountain, embrace a lifestyle that celebrates both comfort and community in sunny Marana, AZ. Your pets will love it here!",
  "property_updated_at": "1786643100239",
  "amenities": [
    {
      "id": "custom_d7592d4d-15b8-4c71-9fab-52ecfc9843e9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f4719d1c-82d2-4ad5-9a1d-198aceac23ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Garages*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_efe1db40-8fa8-4df3-a269-86a5d5abf462",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_480ac5e1-9d29-4e63-97a7-5d875f3d4a1c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9960fc6d-ee18-4eb6-a1af-0c3189862d32",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_987b0669-3a1e-4e6e-bfbc-cd1e3c78dc2b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_23ed9bd4-cb0d-4489-b9a4-7fbe07bec4d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Relaxing Spa w/ Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3f972fc9-e866-4c09-b87f-b018a8147511",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Heated Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_54733580-6ddc-4a3b-a68e-746c51fe2b81",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Online Payment Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_db8d2acc-7923-4197-9a5a-cf8cd5492155",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Professional 24 hr On-Site Maintenance Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_729ab982-b391-4a49-8823-89e61f8534e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_32a735b8-bf2d-4334-8ca8-a54e38eb95d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_96edb2ba-3837-4d54-ae4b-0be4664ef232",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Kitchen w/ Oversized Countertops*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ec6c7754-e570-458f-b721-e53976e617f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Style Flooring and Plush Carpeting*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e3c131fa-db71-4977-a0f2-7299abad910e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Large Private Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b3e8a861-7fa0-4f63-a924-15f5a2e0bf2a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_451a25ec-b967-4423-897e-d5f8a5e2cc06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_de9ea8be-fe74-449b-b42b-1be9b1cc0e6a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7a25254a-1937-477f-a4fc-3bc22fd72385",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Espresso Cabinetry with Brushed Nickel Hardware*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a9e61901-b093-49b3-9b6b-d9252b7e7c2c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances w/ Ice Maker*",
      "amount": "false",
      "description": "*In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0ecbbc32-2b38-4ba5-ab5f-76d8cdeb1e33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Property Wide Fiber Optic Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ba3ed8a2-d697-4a45-9201-74e6cf233328",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Full size Washer and Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3e97cadd-d9fd-43de-b1b7-d48a61d63a18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b075b85a-9591-4760-9f45-b3c33d2b8617",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Office Space",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0be839c1-d9a0-40c6-b9f4-13bce4d8e7dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-c555-704b-9305-c79e1d78269a.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings and carports, set against a backdrop of desert mountains  at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-c555-704b-9305-c79e1d78269a",
        "storage_key": "property/6767906449166439/01a016e0-c555-704b-9305-c79e1d78269a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Expansive aerial view showcases the modern architecture of this multifamily property, featuring numerous apartment buildings, covered parking, and surrounded by natural desert landscape and distant mountains.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings and carports, set against a backdrop of desert mountains  at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe26e046-7f96-414d-bb6c-c0f0fc4f066d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-7e57-71cf-b757-357d0ed077ec.webp",
      "image_media": {
        "alt_text": "Entryway to Legacy Apartments at Dove Mountain, featuring stone pillars with plants and a modern archway at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-7e57-71cf-b757-357d0ed077ec",
        "storage_key": "property/6767906449166439/01a016e0-7e57-71cf-b757-357d0ed077ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Legacy Apartments at Dove Mountain. Experience comfortable living with our stunning exteriors and welcoming entrance.",
      "link": "",
      "alt_text": "Entryway to Legacy Apartments at Dove Mountain, featuring stone pillars with plants and a modern archway at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_120ee06d-db4e-43dc-88ed-1c98265fa199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-99fb-7092-94c5-e85af8ee0b49.webp",
      "image_media": {
        "alt_text": "Courtyard with a pathway, bench, and desert landscaping at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-99fb-7092-94c5-e85af8ee0b49",
        "storage_key": "property/6767906449166439/01a016e0-99fb-7092-94c5-e85af8ee0b49.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautifully maintained courtyards, complete with a bench and walking paths, surrounded by lush desert flora.",
      "link": "",
      "alt_text": "Courtyard with a pathway, bench, and desert landscaping at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71b6dc6a-f92c-4e5b-a9ca-86c637bcb6fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-7757-7202-9229-9b4eb8cdff0c.webp",
      "image_media": {
        "alt_text": "Lounge area with bar and seating at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-7757-7202-9229-9b4eb8cdff0c",
        "storage_key": "property/6767906449166439/01a016e0-7757-7202-9229-9b4eb8cdff0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the community lounge, featuring a stylish bar area with counter seating and comfortable seating for socializing. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Lounge area with bar and seating at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cbd7e461-5f2d-4126-8ac2-cbc960be4510",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-8efc-74c9-89e1-9c879ccca0bd.webp",
      "image_media": {
        "alt_text": "Modern lounge area with pool table, fireplace, and seating at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-8efc-74c9-89e1-9c879ccca0bd",
        "storage_key": "property/6767906449166439/01a016e0-8efc-74c9-89e1-9c879ccca0bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a pool table, elegant fireplace, and comfortable seating areas perfect for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Modern lounge area with pool table, fireplace, and seating at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab356d86-2b2e-4eb0-bbc6-12fa1c93b2e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-9292-779b-a435-4d0d6a8a73f3.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, elliptical machines, weight machines, and a yoga mat at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-9292-779b-a435-4d0d6a8a73f3",
        "storage_key": "property/6767906449166439/01a016e0-9292-779b-a435-4d0d6a8a73f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, strength training equipment, and a dedicated space for yoga and stretching.",
      "link": "",
      "alt_text": "Modern gym with treadmills, elliptical machines, weight machines, and a yoga mat at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d018b78e-6172-42b4-a633-a7796ab55cfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-55e2-75cc-9e00-4a484c907936.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and blue umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-55e2-75cc-9e00-4a484c907936",
        "storage_key": "property/6767906449166439/01a016e0-55e2-75cc-9e00-4a484c907936.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool or relax in the soothing spa. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and spa area with lounge chairs and blue umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1ff7c8c-67f7-4847-bbdc-00e0d0dd26b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016df-f054-773b-bc6d-778b661a383f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Legacy Apartments.",
        "public_id": "01a016df-f054-773b-bc6d-778b661a383f",
        "storage_key": "property/6767906449166439/01a016df-f054-773b-bc6d-778b661a383f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and shade umbrellas, offering a perfect oasis for unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Legacy Apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99430530-0fd5-48ce-a41e-b3645e4330e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-16eb-7635-bfd0-5b0bb509bead.webp",
      "image_media": {
        "alt_text": "A community swimming pool and hot tub area with lounge chairs and blue umbrellas, surrounded by apartment buildings and desert landscaping at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-16eb-7635-bfd0-5b0bb509bead",
        "storage_key": "property/6767906449166439/01a016e0-16eb-7635-bfd0-5b0bb509bead.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and hot tub, perfect for relaxation and soaking up the sun. The surrounding area offers comfortable lounge seating and vibrant blue umbrellas for shade.",
      "link": "",
      "alt_text": "A community swimming pool and hot tub area with lounge chairs and blue umbrellas, surrounded by apartment buildings and desert landscaping at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e7e4dfb-a742-49b4-a152-77b736ce7fbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016df-feb9-70dc-9f4d-79fd4f512200.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills, tables, and umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016df-feb9-70dc-9f4d-79fd4f512200",
        "storage_key": "property/6767906449166439/01a016df-feb9-70dc-9f4d-79fd4f512200.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our outdoor grilling station, perfect for al fresco dining and socializing with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills, tables, and umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86a6983a-3f49-4203-a071-d6ffe7ee4b07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-95b0-779a-8f40-f65875a79b77.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor lounge area with a fire pit, seating, umbrellas, and pool.",
        "public_id": "01a016e0-95b0-779a-8f40-f65875a79b77",
        "storage_key": "property/6767906449166439/01a016e0-95b0-779a-8f40-f65875a79b77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the fire pit in our outdoor lounge, complete with comfortable seating and umbrellas. Enjoy the pool and desert landscaping.",
      "link": "",
      "alt_text": "Apartment complex outdoor lounge area with a fire pit, seating, umbrellas, and pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7897fb96-7810-42c2-8f81-b036a7fa362e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-907e-73c9-ad70-d8f8eccdd73a.webp",
      "image_media": {
        "alt_text": "Putting green with red flags at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-907e-73c9-ad70-d8f8eccdd73a",
        "storage_key": "property/6767906449166439/01a016e0-907e-73c9-ad70-d8f8eccdd73a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a round of golf at our community putting green, perfect for honing your short game.",
      "link": "",
      "alt_text": "Putting green with red flags at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_729cc6de-3404-4cb2-88c4-e7821dd99d0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-8f58-7718-9fc0-5b3a9618609e.webp",
      "image_media": {
        "alt_text": "Package lockers in a multifamily property at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-8f58-7718-9fc0-5b3a9618609e",
        "storage_key": "property/6767906449166439/01a016e0-8f58-7718-9fc0-5b3a9618609e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure package lockers available for residents, featuring a modern design and a convenient touchscreen interface.",
      "link": "",
      "alt_text": "Package lockers in a multifamily property at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_183c92dc-c504-47cb-bd90-ea4496d9afcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-92d9-703a-b34b-13e69b154672.webp",
      "image_media": {
        "alt_text": "Mailboxes with numbers and U.S. Mail slots at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-92d9-703a-b34b-13e69b154672",
        "storage_key": "property/6767906449166439/01a016e0-92d9-703a-b34b-13e69b154672.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure mailboxes with individual numbered slots and U.S. Mail compartments, providing convenient mail service for residents.",
      "link": "",
      "alt_text": "Mailboxes with numbers and U.S. Mail slots at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41f3a53b-c827-48e5-9493-571ce682d4ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-6a9d-7188-91b2-973b7d974ce8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-6a9d-7188-91b2-973b7d974ce8",
        "storage_key": "property/6767906449166439/01a016e0-6a9d-7188-91b2-973b7d974ce8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this sleek kitchen, featuring stainless steel appliances, ample cabinet space, and a stylish countertop. Perfect for the home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba2d4132-5985-4c22-af2c-6d87f95c1fb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e8-1127-71ca-99e7-0fa6f81c8cd2.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with dark cabinetry, stainless steel appliances, and view of living area at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e8-1127-71ca-99e7-0fa6f81c8cd2",
        "storage_key": "property/6767906449166439/01a016e8-1127-71ca-99e7-0fa6f81c8cd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinets, granite countertops, a stainless steel dishwasher, oven, and microwave. Opens to a bright living space.",
      "link": "",
      "alt_text": "Modern apartment kitchen with dark cabinetry, stainless steel appliances, and view of living area at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_547c1ccd-8f8e-4e8a-ac44-2e9ec0ace9b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f66a3-e292-726b-9406-c38d7924ff43.webp",
      "image_media": {
        "alt_text": "Living room with dining area and a television at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "019f66a3-e292-726b-9406-c38d7924ff43",
        "storage_key": "property/6767906449166439/019f66a3-e292-726b-9406-c38d7924ff43.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This apartment living room features a dining area with a marble table and chairs, a comfortable sofa, and a mounted television.",
      "link": "",
      "alt_text": "Living room with dining area and a television at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0afdd2b0-b708-46cd-8448-9daf0a0f2718",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-5029-7559-8e12-e2534efd4730.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, leather accent chair, marble coffee table, and a TV.",
        "public_id": "01a016e0-5029-7559-8e12-e2534efd4730",
        "storage_key": "property/6767906449166439/01a016e0-5029-7559-8e12-e2534efd4730.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, accent chair, and a modern coffee table, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a white sofa, leather accent chair, marble coffee table, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c7d177c-e5d1-4b48-b5e3-280be8b15177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-7c5f-73bf-ac0b-477b7b0cee83.webp",
      "image_media": {
        "alt_text": "King-sized bed with white linens and decorative pillows in a bedroom with a ceiling fan and large mirror at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-7c5f-73bf-ac0b-477b7b0cee83",
        "storage_key": "property/6767906449166439/01a016e0-7c5f-73bf-ac0b-477b7b0cee83.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-sized bed, modern ceiling fan, and ample natural light. Perfect for relaxation.",
      "link": "",
      "alt_text": "King-sized bed with white linens and decorative pillows in a bedroom with a ceiling fan and large mirror at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b18db9c-d181-42ed-b80d-b390f90c4029",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f66a3-e2db-772c-ad08-00bc464b05fd.webp",
      "image_media": {
        "alt_text": "Hallway with linen closet and doorway to bedroom at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "019f66a3-e2db-772c-ad08-00bc464b05fd",
        "storage_key": "property/6767906449166439/019f66a3-e2db-772c-ad08-00bc464b05fd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "View of a hallway featuring a spacious linen closet with organized shelving and a doorway leading into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Hallway with linen closet and doorway to bedroom at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da451aa5-50c0-45ca-a5a8-416eabff584c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-45a4-747f-820f-f84c652ce00c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
        "public_id": "01a016e0-45a4-747f-820f-f84c652ce00c",
        "storage_key": "property/6767906449166439/01a016e0-45a4-747f-820f-f84c652ce00c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a sleek vanity with ample counter space, a modern toilet, and a clean shower/tub combination with a decorative curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfc25d1b-8015-4aa9-9d19-78f78b9e7c68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e6-51d3-75ab-ae24-314398973069.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, a dresser, and a ceiling fan at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e6-51d3-75ab-ae24-314398973069",
        "storage_key": "property/6767906449166439/01a016e6-51d3-75ab-ae24-314398973069.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a plush king-size bed, elegant nightstands, a spacious dresser, and a modern ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, a dresser, and a ceiling fan at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56162460-9d9b-4d12-a6d7-9e458045d897",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f66a3-ea31-7728-9073-34b396d78ecd.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving and hanging rods at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "019f66a3-ea31-7728-9073-34b396d78ecd",
        "storage_key": "property/6767906449166439/019f66a3-ea31-7728-9073-34b396d78ecd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving, hanging space, and a decorative ottoman for added convenience.",
      "link": "",
      "alt_text": "Walk-in closet with shelving and hanging rods at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b10fe628-733a-4476-b714-2cae935b1bfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/01a016e0-9542-732d-b93d-2cf9cbb5fa2d.webp",
      "image_media": {
        "alt_text": "Balcony with wicker chairs and potted plants, overlooking a courtyard with trees and umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
        "public_id": "01a016e0-9542-732d-b93d-2cf9cbb5fa2d",
        "storage_key": "property/6767906449166439/01a016e0-9542-732d-b93d-2cf9cbb5fa2d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, complete with comfortable seating and lush greenery.",
      "link": "",
      "alt_text": "Balcony with wicker chairs and potted plants, overlooking a courtyard with trees and umbrellas at Legacy Apartments at Dove Mountain in Marana, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1f500fa1-0cad-4740-8496-cf829230baa9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Oasis Golf Club & Lounge",
      "poi_type": "Entertainment",
      "poi_address": "9290 N Thornydale Rd Suite 108, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this indoor golf course offers golf simulators, a putting area, and multiple large screens for watching games. They highlight the fun and chill vibe, and the comfortable seating. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-2ba1-7047-b9ed-76d1279ef4df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-2ba1-7047-b9ed-76d1279ef4df",
        "storage_key": "property/6767906449166439/019d02cc-2ba1-7047-b9ed-76d1279ef4df.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://oasisgolftucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7759588185707885318&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oasis-golf-club--lounge",
      "poi_latitude": "32.3750029",
      "poi_longitude": "-111.0460503",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-308-4840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-af28-74df-b21a-1d31ea95d66b",
        "storage_key": "property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29RUWbQL1oYRBrNvxFeYr2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_golf_course"
    },
    {
      "id": "custom_5ca426c5-f974-44b4-acfa-d6df1f458acf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Harkins Theatres Arizona Pavilions",
      "poi_type": "Entertainment",
      "poi_address": "5755 Arizona Pavilions Dr, Tucson, AZ 85743, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "People say this movie theater offers great popcorn and shows the latest movies. They highlight the clean theaters and restrooms, and the comfortable seating with a great sound system. They also like the friendly and helpful staff, and the quick service at the concessions and ticket booth. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-2a58-7167-b61e-b47664c8c007.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-2a58-7167-b61e-b47664c8c007",
        "storage_key": "property/6767906449166439/019d02cc-2a58-7167-b61e-b47664c8c007.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "https://harkins.com/theatres/arizona-pavilions?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13794272010304611144&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-arizona-pavilions",
      "poi_latitude": "32.3519",
      "poi_longitude": "-111.0877",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-230-4730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-49b3-7568-92bd-3f8cd13e8e25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-49b3-7568-92bd-3f8cd13e8e25",
        "storage_key": "property/6767906449166439/019d02cc-49b3-7568-92bd-3f8cd13e8e25.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22P0KqIK1oYRSONR5U4Zb78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f0a2bc3e-ea5f-4532-bf8b-2ae86cb06da8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Tangerine Sky Community Park",
      "poi_type": "Entertainment",
      "poi_address": "4411 W Tangerine Rd, Marana, AZ 85658, USA",
      "poi_short_description": "Ample park for families featuring a zip line and climbing equipment.",
      "poi_long_description": "People say this park offers a variety of activities, including multiple playgrounds, swings, a zip line, and a dog park. They highlight the park's clean and well-maintained facilities, as well as the ample shade, seating, and parking. They also like the family-friendly atmosphere and the convenient access to restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-2c16-76cd-ac57-54e9094610ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-2c16-76cd-ac57-54e9094610ce",
        "storage_key": "property/6767906449166439/019d02cc-2c16-76cd-ac57-54e9094610ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://maranaaz.gov/recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15964054537325045706&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tangerine-sky-community-park",
      "poi_latitude": "32.4223254",
      "poi_longitude": "-111.0618156",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-382-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae51-715c-9ae7-726b1952fe65",
        "storage_key": "property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5hl7xcJ1oYRyuc4QAW3i90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_05bd5c6f-2b81-4612-83a4-c1183d01bd63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Topgolf Tucson",
      "poi_type": "Entertainment",
      "poi_address": "4050 W Costco Dr, Tucson, AZ 85741, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with plenty of gameplay options and decent food. They highlight the relaxed and enjoyable atmosphere, and the friendly and attentive staff. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-2b0a-76b6-b2b5-3ee825647044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-2b0a-76b6-b2b5-3ee825647044",
        "storage_key": "property/6767906449166439/019d02cc-2b0a-76b6-b2b5-3ee825647044.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/tucson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14538694303913613378&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-tucson",
      "poi_latitude": "32.3286955",
      "poi_longitude": "-111.0526827",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-284-5047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2PlCCZ11oYRQhjEqnDRw8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7e998718-566f-4349-bdfc-ea71f0fe00a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Kon-Ni-Chi-Claw",
      "poi_type": "Entertainment",
      "poi_address": "6401 Marana Center Blvd #908, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement center offers great prizes and has a fun vibe.\n\nOther reviews mention the claw machines can be rigged and the claws can be weak.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-30fe-74b6-b21a-a192b49e02e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-30fe-74b6-b21a-a192b49e02e4",
        "storage_key": "property/6767906449166439/019d02cc-30fe-74b6-b21a-a192b49e02e4.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://konnichiclaw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14849127638677687644&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kon-ni-chi-claw",
      "poi_latitude": "32.3752456",
      "poi_longitude": "-111.1003398",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoS5FGEnh1YYRXI3Rz-myEs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_96441b38-efc7-4aa8-8127-c05c31dc9358",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Elevate Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "9705 N Thornydale Rd, Tucson, AZ 85742, USA",
      "poi_short_description": "Large recreation center boasting a wide array of trampolines, plus dodgeball and a foam pit.",
      "poi_long_description": "People say this recreation center offers a variety of fun activities, including trampolines, obstacle courses, and a zip line, suitable for different age groups. They highlight the good value, especially with the monthly membership, and the clean facilities. They also like the friendly staff and good customer service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3123-71b2-b437-17acf24b114f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3123-71b2-b437-17acf24b114f",
        "storage_key": "property/6767906449166439/019d02cc-3123-71b2-b437-17acf24b114f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://elevatetrampolinepark.com/tucson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17153791749315562512&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "elevate-trampoline-park",
      "poi_latitude": "32.3823717",
      "poi_longitude": "-111.0487419",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-505-4665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRPOEUML1oYREAz7GLaCDu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_f3720cf6-8715-46dd-bda3-c23210615126",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "8030 N Cortaro Rd, Tucson, AZ 85743, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of items, including clothing, accessories, and home goods. They also highlight the reasonable prices and good deals on high-end products.\n\nSome reviews mention there can be long lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8815-7453-80cd-33481163380d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8815-7453-80cd-33481163380d",
        "storage_key": "property/6767906449166439/019d02ca-8815-7453-80cd-33481163380d.webp",
        "width": 1164,
        "height": 657
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15047986838569377454&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "32.3530555",
      "poi_longitude": "-111.0933457",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-572-8969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwanJBqAK1oYRrl6uUU0w1dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_b3a85351-e187-43e0-ad34-8fce205ece57",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Old Navy Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd SUITE 309, Tucson, AZ 85742, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3483-72ad-8a55-1e994f1e9066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3483-72ad-8a55-1e994f1e9066",
        "storage_key": "property/6767906449166439/019d02cc-3483-72ad-8a55-1e994f1e9066.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/az/tucson/oldnavy-7194.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16406447755415477314&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy-outlet",
      "poi_latitude": "32.3750774",
      "poi_longitude": "-111.0999593",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-476-3182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-X6YfNHh1YYRQlyL905pr-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_49ac1af0-78ed-4814-94e9-be250813dca3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd Ste 303, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJn4uKPQDh1YYRbErvU2efkZQ/photos/ATCDNfUy7k0P_g7TmpM-oA_EwhihmWe2j5fYqPVEw9ZuJ7ogPuVyysK83aDfQ1f5ky4-Ja5AnZn_urSS54FjlK3ZrLItmJvynEIzg-2xpJLl21BI1kZcTc70EmcwuUm1nnelBs7a8SBrMUt_ZyVNu9oe4J0kxmlRvf8Ttmfnv-iAQiK8JC8eYtFk66QnvxzhRQS1jSXTDLHJAjWuJGK-ly8mUes6QK1-ZC0NAjSkB2YcznBmJPGDi3JD8rvdxNWV2ZR3auC4RSu2n4vVZEj73jgpNxePwgfjVHmGbDUqIpTLp48ujw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=720&maxHeightPx=405",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ulta.com/stores/tucson-az-2034",
      "poi_directions_map_url": "https://maps.google.com/?cid=10705513055375018604&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "32.3749159",
      "poi_longitude": "-111.0999487",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-910-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn4uKPQDh1YYRbErvU2efkZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_c289182c-6fa8-4f0c-a07d-22bc2c7f5788",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Tangerine Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "Tangerine Crossing, Marana, AZ 85658, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4123405025573744902&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tangerine-crossing",
      "poi_latitude": "32.4286646",
      "poi_longitude": "-111.0415698",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3a0tcH4J1oYRBjFiJgZHOTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_febe6747-2ce6-487d-a9af-894fda87aaa3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Tucson Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd, Tucson, AZ 85742, USA",
      "poi_short_description": "Family-friendly outdoor mall featuring a play area and a fire pit.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores, including many top-quality name brands and specialty shops. They highlight the spacious layout, ample parking, and the availability of shade and outdoor seating. They also like the clean and well-maintained facilities, including the food court and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3726-71d1-b017-1edff49c78a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3726-71d1-b017-1edff49c78a4",
        "storage_key": "property/6767906449166439/019d02cc-3726-71d1-b017-1edff49c78a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tucson",
      "poi_directions_map_url": "https://maps.google.com/?cid=11469359100388911255&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-premium-outlets",
      "poi_latitude": "32.3758462",
      "poi_longitude": "-111.1017025",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-385-7726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu5Ooq47h1YYRlygTpFVZK58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_629b425e-8dc4-4380-a888-04b8b3241359",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Nico's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "12090 N Thornydale Rd, Marana, AZ 85658, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, enchiladas, and burritos. They also highlight the generous portions and clean restrooms.\n\nOther reviews mention the service can be unfriendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-378c-74bd-8847-d27591b398a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-378c-74bd-8847-d27591b398a1",
        "storage_key": "property/6767906449166439/019d02cc-378c-74bd-8847-d27591b398a1.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6287639562534021727&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nicos-taco-shop",
      "poi_latitude": "32.4259706",
      "poi_longitude": "-111.0458786",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-433-0072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYi_nbkL1oYRX2qIaN4uQlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4f428fae-55c8-4a95-85f9-e99e96bb4115",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5975 Arizona Pavilions Dr, Tucson, AZ 85743, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious burgers. They also highlight the great value for the price and the friendly, attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3841-7381-b175-43cbca37201f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3841-7381-b175-43cbca37201f",
        "storage_key": "property/6767906449166439/019d02cc-3841-7381-b175-43cbca37201f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/arizona/tucson/cortaro?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=13641662866861164139&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "32.354452",
      "poi_longitude": "-111.092304",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-572-9065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XelKp4K1oYRa4blzBnsUL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f3a6e31b-f0a8-4c6d-b729-2949b4124a47",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Cracker Barrel Rd, Tucson, AZ 85743, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, meatloaf, and catfish, and offers a wide variety of comfort food options. They also highlight the fast service, friendly staff, and the charming, old-country atmosphere with a gift shop.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-7c4c-718b-b6d3-8407757dec66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-7c4c-718b-b6d3-8407757dec66",
        "storage_key": "property/6767906449166439/019d02ca-7c4c-718b-b6d3-8407757dec66.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/az/tucson/344/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722503852762286687&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "32.359897",
      "poi_longitude": "-111.0926572",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-1845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZF-5J0K1oYRX0r_iqdEEug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c848e8eb-c22b-4fcf-a881-6712725513e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8450 N Cracker Barrel Rd, Marana, AZ 85743, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious prime rib, ribs, and steaks, and the rolls with cinnamon butter are a must-try. They highlight the generous portions, good value, and fun, lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3cef-7647-bc09-cdd692a316cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3cef-7647-bc09-cdd692a316cb",
        "storage_key": "property/6767906449166439/019d02cc-3cef-7647-bc09-cdd692a316cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arizona/marana?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6561850984109631979&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.3606036",
      "poi_longitude": "-111.0932403",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-3855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP17Njp0K1oYR6-nmMLRgEFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_e7f80b16-c21c-469a-ac33-f30bfde19ca1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Amore—Dove Mountain",
      "poi_type": "Restaurants",
      "poi_address": "12130 N Dove Mountain Blvd #104, Marana, AZ 85658, USA",
      "poi_short_description": "Neapolitan pizzeria firing pies in a wood-burning oven & serving Italian dishes in a casual space.",
      "poi_long_description": "People say this pizza restaurant serves delicious Italian food, including chicken picatta, pizza, and pasta. They also highlight the fresh ingredients, generous portions, and reasonable prices.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-413c-758a-a822-b66803641dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-413c-758a-a822-b66803641dbe",
        "storage_key": "property/6767906449166439/019d02cc-413c-758a-a822-b66803641dbe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://amoretucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16543967091737867162&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amoredove-mountain",
      "poi_latitude": "32.4273216",
      "poi_longitude": "-111.0789509",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-2292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwYzg_kJ1oYRmrPJjmr6l-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_0c54bdba-f6ae-47c7-bb2b-cec348459131",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Dove Mountain Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "12130 N Dove Mountain Blvd, Marana, AZ 85658, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this restaurant offers a great selection of local beers, tasty food like BBQ burgers, fish and chips, and onion rings, and a lively outdoor seating area with misters and shade. They also highlight the friendly and attentive service, reasonable prices, and family-friendly atmosphere.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cc-3cd9-770c-bca1-690bfa9a687a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-3cd9-770c-bca1-690bfa9a687a",
        "storage_key": "property/6767906449166439/019d02cc-3cd9-770c-bca1-690bfa9a687a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.dovemountainbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5580046761897642936&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-mountain-brewing-company",
      "poi_latitude": "32.4274101",
      "poi_longitude": "-111.0792388",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9f2-7261-a80f-94d70b762d98",
        "storage_key": "property/6767906449166439/019d02ca-a9f2-7261-a80f-94d70b762d98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh2LS3fAJ1oYRuEv6MPdOcE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bf8a2d00-d56b-411a-a85f-6dcd0da199b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Oro Valley Public Library",
      "poi_type": "Education",
      "poi_address": "1305 W Naranja Dr, Oro Valley, AZ 85737, USA",
      "poi_short_description": "Public library offering resources for adults and children, including books and comfortable seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8816-753c-89a7-200d31e48b3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8816-753c-89a7-200d31e48b3c",
        "storage_key": "property/6767906449166439/019d02ca-8816-753c-89a7-200d31e48b3c.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.library.pima.gov/locations/ORO",
      "poi_directions_map_url": "https://maps.google.com/?cid=11295292608261941214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oro-valley-public-library",
      "poi_latitude": "32.4089007",
      "poi_longitude": "-110.9944721",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-594-5580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtzaKJXQM1oYR3meMPcjwwJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_08bc4656-4741-4eb5-871d-6232b62a4334",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Wheeler Taft Abbett Sr. Library",
      "poi_type": "Education",
      "poi_address": "7800 N Schisler Dr, Tucson, AZ 85743, USA",
      "poi_short_description": "Public library with computers, a special area for kids, and a gender-neutral restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8932-741f-8579-f3091488f143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8932-741f-8579-f3091488f143",
        "storage_key": "property/6767906449166439/019d02ca-8932-741f-8579-f3091488f143.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.library.pima.gov/locations/ABB/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15452651577029261436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wheeler-taft-abbett-sr-library",
      "poi_latitude": "32.348893",
      "poi_longitude": "-111.095118",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-594-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM6Fjbx7g1YYRfHi11rzYctY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5279c650-5450-4be1-8cdc-f49fb979b442",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5885 Arizona Pavilions Dr, Tucson, AZ 85743, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, including platforms and Olympic weights. They also highlight the friendly and helpful staff, and the clean and well-maintained facility.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8e11-714e-8aaa-eee0f16d8db6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8e11-714e-8aaa-eee0f16d8db6",
        "storage_key": "property/6767906449166439/019d02ca-8e11-714e-8aaa-eee0f16d8db6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=617&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6006765760383350924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.3528063",
      "poi_longitude": "-111.0909498",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-342-0809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4RqqU1jk1YYRjPigRKJRXFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_65bb003b-7a32-4923-97d0-ef18ece0e502",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "HOTWORX - Tucson, AZ - Marana",
      "poi_type": "Health and Wellness",
      "poi_address": "7575 W Twin Peaks Rd Suite 135, Tucson, AZ 85743, USA",
      "poi_short_description": "Sauna-equipped studio for hot Pilates, yoga, barre, and cycle classes.",
      "poi_long_description": "People say this yoga studio offers a variety of intense and refreshing infrared sauna workouts, including HIIT and isometric training sessions. They highlight the 24/7 access, the clean and well-maintained saunas, and the individual space provided during workouts. They also like the friendly and welcoming staff, and the supportive community. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8dcd-7506-9b00-093c734de36e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8dcd-7506-9b00-093c734de36e",
        "storage_key": "property/6767906449166439/019d02ca-8dcd-7506-9b00-093c734de36e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hotworx.net/studio/tucson-marana/",
      "poi_directions_map_url": "https://maps.google.com/?cid=262274578653034345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hotworx---tucson-az---marana",
      "poi_latitude": "32.3742329",
      "poi_longitude": "-111.1264257",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 520-638-7704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIf0SKMjh1YYRabc69lbJowM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_0f3daf34-e2f3-40f6-b3de-eb1ed60f283f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Delicate Nails Spa Cortaro - Nail Salon , Tucson AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "8150 N Cortaro Rd Ste 140, Tucson, AZ 85743, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8cfe-7638-a307-012740b12198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8cfe-7638-a307-012740b12198",
        "storage_key": "property/6767906449166439/019d02ca-8cfe-7638-a307-012740b12198.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://delicatenailstucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6857355170630347705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delicate-nails-spa-cortaro---nail-salon--tucson-az",
      "poi_latitude": "32.3546251",
      "poi_longitude": "-111.0933061",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-744-7583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcCx6J8K1oYRuSscJDI4Kl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_a1fd412a-557c-43f8-b340-2f5e62b585ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Continental Ranch Pet Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "7850 N Silverbell Rd # 108, Tucson, AZ 85743, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-8ffb-77c9-96d0-efec3711ceaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-8ffb-77c9-96d0-efec3711ceaa",
        "storage_key": "property/6767906449166439/019d02ca-8ffb-77c9-96d0-efec3711ceaa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://continentalranchpetclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14825526187575786509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "continental-ranch-pet-clinic",
      "poi_latitude": "32.3499793",
      "poi_longitude": "-111.0985734",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-744-3850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6N5Mxng1YYRDby0woTZvs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1c9d5d54-bd91-4709-a5bc-db97db97cb73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Dove Mountain Veterinary",
      "poi_type": "Health and Wellness",
      "poi_address": "12110 N Dove Mountain Blvd, Marana, AZ 85658, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-923e-7297-a495-8f74f344604b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-923e-7297-a495-8f74f344604b",
        "storage_key": "property/6767906449166439/019d02ca-923e-7297-a495-8f74f344604b.webp",
        "width": 561,
        "height": 314
      },
      "poi_business_url": "https://dovemountainvet.com/?utm_source=gmb&utm_medium=organic&y_source=1_NTUyMDgzODEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13050832258627685042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dove-mountain-veterinary",
      "poi_latitude": "32.4269214",
      "poi_longitude": "-111.0797807",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 520-448-9690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZBAxPAJ1oYRskq2_sreHbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_2c2b853b-388c-4d51-b81c-4516acbcdb8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Sharkey's Cuts for Kids - Tucson, AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "3605 W Cortaro Farms Rd Ste 149, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-940d-77f0-9539-6f749ae46041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-940d-77f0-9539-6f749ae46041",
        "storage_key": "property/6767906449166439/019d02ca-940d-77f0-9539-6f749ae46041.webp",
        "width": 997,
        "height": 1280
      },
      "poi_business_url": "https://sharkeyscutsforkidstucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17557373522338775377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharkeys-cuts-for-kids---tucson-az",
      "poi_latitude": "32.3585536",
      "poi_longitude": "-111.0440967",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-308-4259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-P9UwAL1oYRUQHaEzJSqPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d05ff384-b1fe-4141-99c4-d992ed1e0872",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Flourish Yoga Tucson",
      "poi_type": "Health and Wellness",
      "poi_address": "3605 W Cortaro Farms Rd #115, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this yoga studio offers a variety of hot and warm yoga classes, with knowledgeable and encouraging instructors. They also highlight the welcoming and friendly atmosphere, and the refreshing cold towels provided at the end of class.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-940c-71f8-8137-0e9d27c2bc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-940c-71f8-8137-0e9d27c2bc39",
        "storage_key": "property/6767906449166439/019d02ca-940c-71f8-8137-0e9d27c2bc39.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "http://flourishyogatucson.com/?utm_source=google&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=4390389409954364212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flourish-yoga-tucson",
      "poi_latitude": "32.3585536",
      "poi_longitude": "-111.0440967",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-308-5497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIzBtnhoL1oYRNHv3NejL7Tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_ec5c60fe-31e6-49eb-b700-e7ad8376a2ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Salon Blonde",
      "poi_type": "Health and Wellness",
      "poi_address": "12120 N Dove Mountain Blvd #162, Marana, AZ 85658, USA",
      "poi_short_description": "Straightforward hair salon offering cuts, coloring, Brazilian straightening and highlights treatments by friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-9758-7440-8251-004db7ec7547.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9758-7440-8251-004db7ec7547",
        "storage_key": "property/6767906449166439/019d02ca-9758-7440-8251-004db7ec7547.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://salonblonde.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9806902265858992648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-blonde",
      "poi_latitude": "32.42715460000001",
      "poi_longitude": "-111.0786741",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 520-770-7874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6eGYPAJ1oYRCKp_z6YdGYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7fbd7cc6-77f5-4869-a137-9ec637f1f0bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7475 W Twin Peaks Rd, Tucson, AZ 85743, USA",
      "poi_short_description": "Gym featuring cardio machines and free weights, plus tanning and fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-9a11-72ce-8e6d-29151e7b94e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9a11-72ce-8e6d-29151e7b94e6",
        "storage_key": "property/6767906449166439/019d02ca-9a11-72ce-8e6d-29151e7b94e6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/tucson-arizona-440/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=440",
      "poi_directions_map_url": "https://maps.google.com/?cid=4991884239993696681&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "32.3741495",
      "poi_longitude": "-111.1250917",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 520-844-4284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk8gM6LPh1YYRqfGxpES8RkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_adefcfd3-26b3-4bf8-9b73-494d94c8bdea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Carondelet Marana Emergency Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5620 W Cortaro Farms Rd, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-9b55-777f-bd18-7e1e25a5e14f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9b55-777f-bd18-7e1e25a5e14f",
        "storage_key": "property/6767906449166439/019d02ca-9b55-777f-bd18-7e1e25a5e14f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carondelet.org/location/detail/marana-hospital/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-carondelet-marana-hosp&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5916061905256542882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carondelet-marana-emergency-center",
      "poi_latitude": "32.3606905",
      "poi_longitude": "-111.085575",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-872-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae3e-75e8-88fa-ca84bd8f03d4",
        "storage_key": "property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSWKTR4L1oYRonIJTPUSGlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c357031f-2633-492a-aa00-598866953403",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Quarry Pines Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8480 N Continental Links Dr, Tucson, AZ 85743, USA",
      "poi_short_description": "Scenic course nestled in a former quarry, known for its elevation changes.",
      "poi_long_description": "People say this golf course offers a challenging layout with elevation changes, narrow fairways, and good greens. They also highlight the great views, good rates, and friendly staff.\n\nOther reviews mention the bunkers can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-9d7d-76e3-a393-62ccdd240fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9d7d-76e3-a393-62ccdd240fc4",
        "storage_key": "property/6767906449166439/019d02ca-9d7d-76e3-a393-62ccdd240fc4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.playthepines.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12450697418263991472&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quarry-pines-golf-club",
      "poi_latitude": "32.3615635",
      "poi_longitude": "-111.0980624",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 520-744-7443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-af28-74df-b21a-1d31ea95d66b",
        "storage_key": "property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJrzfv-Sbg1YYRsJR_1VXDyaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_8ff9ffca-5b88-4284-88b7-f156514a7396",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Crossroads at Silverbell District Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7548 N Silverbell Rd, Tucson, AZ 85743, USA",
      "poi_short_description": "A big green space featuring ball fields and courts for various sports as well as several playgrounds.",
      "poi_long_description": "People say this park offers a splash pad, playground, dog park, and ball fields. They highlight the park is clean, well-maintained, and family-friendly. They also like the shaded areas and the convenient restrooms. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a3cf-700c-8f7c-edb7c3ec5e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a3cf-700c-8f7c-edb7c3ec5e00",
        "storage_key": "property/6767906449166439/019d02ca-a3cf-700c-8f7c-edb7c3ec5e00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maranaaz.gov/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5994114302313525624&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crossroads-at-silverbell-district-park",
      "poi_latitude": "32.3469788",
      "poi_longitude": "-111.0937258",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-382-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae51-715c-9ae7-726b1952fe65",
        "storage_key": "property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH70w-h3g1YYReHF8JDNfL1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0de6834a-e321-45da-8d43-683c5aaba865",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Crooked Tree Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9101 N Thornydale Rd, Tucson, AZ 85742, USA",
      "poi_short_description": "Golf course featuring 18 holes (with six affected by lakes), plus a driving range and a practice green.",
      "poi_long_description": "Par-72 golf course with cactus-lined holes & mountain views, also offering a pro shop & restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a301-773d-a8fd-7289f7484c94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a301-773d-a8fd-7289f7484c94",
        "storage_key": "property/6767906449166439/019d02ca-a301-773d-a8fd-7289f7484c94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.crookedtreegc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13670061295804047483&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crooked-tree-golf-course",
      "poi_latitude": "32.3764512",
      "poi_longitude": "-111.0517925",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 520-744-3366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-af28-74df-b21a-1d31ea95d66b",
        "storage_key": "property/6767906449166439/019d02ca-af28-74df-b21a-1d31ea95d66b.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2mCRisK1oYRe2A3SlLQtb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_22a80341-e612-44d1-9d98-763718dd5c26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Mountain View High School",
      "poi_type": "Education",
      "poi_address": "3901 W Linda Vista Blvd, Tucson, AZ 85742, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f02e9-9f15-737b-9900-fcb9cb6be2c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f02e9-9f15-737b-9900-fcb9cb6be2c8",
        "storage_key": "property/6767906449166439/019f02e9-9f15-737b-9900-fcb9cb6be2c8.webp",
        "width": 1070,
        "height": 560
      },
      "poi_business_url": "https://mountainviewhigh.maranausd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3153147624539712070&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-view-high-school",
      "poi_latitude": "32.3802554",
      "poi_longitude": "-111.0480968",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRU8Blv4K1oYRRmoO9Q47wis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e0ef54e0-ad5a-45df-badb-42b180cda3ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Dove Mountain CSTEM K-8 School",
      "poi_type": "Education",
      "poi_address": "5650 W Moore Rd, Marana, AZ 85658, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f02e9-9f4e-76bc-bb9f-dcdb3b28b4da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f02e9-9f4e-76bc-bb9f-dcdb3b28b4da",
        "storage_key": "property/6767906449166439/019f02e9-9f4e-76bc-bb9f-dcdb3b28b4da.webp",
        "width": 1070,
        "height": 560
      },
      "poi_business_url": "https://dovemountain.maranausd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13224355699734659392&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-mountain-cstem-k-8-school",
      "poi_latitude": "32.439928",
      "poi_longitude": "-111.0873741",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-579-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXU4fw4wJ1oYRQMEYenFZhrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7736ae19-4d4f-40cc-9c1d-c31edda96c6a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Pima Community College - Northwest Campus",
      "poi_type": "Education",
      "poi_address": "7600 N Shannon Rd # D, Tucson, AZ 85709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f02e9-a016-735e-978c-b367de46eb5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f02e9-a016-735e-978c-b367de46eb5e",
        "storage_key": "property/6767906449166439/019f02e9-a016-735e-978c-b367de46eb5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pima.edu/maps-directions/northwest-campus.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3354019875043196557&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pima-community-college---northwest-campus",
      "poi_latitude": "32.3435478",
      "poi_longitude": "-111.0272835",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-206-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZdoWsjQL1oYRjb6MVU7fiy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b941e139-8208-436e-be56-6fa6410bb31f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "The Ritz-Carlton, Dove Mountain",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15000 N Secret Springs Dr, Marana, AZ 85658, USA",
      "poi_short_description": "Luxe accommodations in a premium resort in the desert, plus a 27-hole golf course, a spa & dining.",
      "poi_long_description": "Guests mention this resort offers stunning mountain views, well-maintained grounds, and a wide variety of activities, including hiking trails, multiple pools, and a water slide. They also highlight the delicious food, especially the breakfast buffet, and the exceptional service from the professional and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f02f6-3393-70d8-8863-dfc117605c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f02f6-3393-70d8-8863-dfc117605c2c",
        "storage_key": "property/6767906449166439/019f02f6-3393-70d8-8863-dfc117605c2c.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "https://www.ritzcarlton.com/en/hotels/tusrz-the-ritz-carlton-dove-mountain/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=17538294354296791339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-ritz-carlton-dove-mountain",
      "poi_latitude": "32.4789343",
      "poi_longitude": "-111.0890351",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-572-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f02f6-36fd-76df-b672-e4017c212f37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f02f6-36fd-76df-b672-e4017c212f37",
        "storage_key": "property/6767906449166439/019f02f6-36fd-76df-b672-e4017c212f37.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJnWZ2pScI1oYRK2EZGsuJZPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_665aa77e-858d-47f5-a9dc-d270e888b798",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Nike Factory Store - Marana",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd Ste 522, Tucson, AZ 85742, USA",
      "poi_short_description": "Outlet store at Tucson Premium Outlets offering sportswear and shoes for men, women, and kids.",
      "poi_long_description": "Customers consistently praise this store for its wide variety of shoes, great clearance deals, and exclusive items. The knowledgeable staff also receive high marks for providing excellent service.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b4d5-744a-8280-3a74742ce750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b4d5-744a-8280-3a74742ce750",
        "storage_key": "property/6767906449166439/019f0b0a-b4d5-744a-8280-3a74742ce750.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nike.com/retail/s/nike-factory-store-marana?cp=84620811901_seo_%3Fcp%3D84620811901_seo_&y_source=1_NTQzNzQxMi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8599775924560024767&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nike-factory-store---marana",
      "poi_latitude": "32.3748421",
      "poi_longitude": "-111.1019559",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-744-6499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyzVvPdPh1YYRv1Rby6OKWHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sportswear_store"
    },
    {
      "id": "custom_72944a75-bf96-4cc0-93b9-052eda7d0b82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Gap Factory",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd Ste 536, Tucson, AZ 85742, USA",
      "poi_short_description": "Outlet featuring clothing for adults and kids including jeans and hoodies, plus swimwear.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b3c0-7363-b39d-2c5f3b438a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b3c0-7363-b39d-2c5f3b438a3d",
        "storage_key": "property/6767906449166439/019f0b0a-b3c0-7363-b39d-2c5f3b438a3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gapfactory.com/stores/az/tucson/gap-4261.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2769474451039084785&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gap-factory",
      "poi_latitude": "32.3749313",
      "poi_longitude": "-111.1025503",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-579-9117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsYn1HtPh1YYR8WC0BFcmbyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_0f5afe7e-530f-4273-bffa-f14eb833128f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "adidas Outlet Store Tucson",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 Marana Center Blvd, Tucson, AZ 85742, USA",
      "poi_short_description": "Retail store featuring the brand's signature athletic footwear, clothes & accessories.",
      "poi_long_description": "Retail store featuring the brand's signature athletic footwear, clothes & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b428-769e-b78a-9ee562de1b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b428-769e-b78a-9ee562de1b0e",
        "storage_key": "property/6767906449166439/019f0b0a-b428-769e-b78a-9ee562de1b0e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://go.adidas.com/ihha/11c0ab86",
      "poi_directions_map_url": "https://maps.google.com/?cid=8250399547481321574&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "adidas-outlet-store-tucson",
      "poi_latitude": "32.3755",
      "poi_longitude": "-111.1019",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-353-3390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e",
        "storage_key": "property/6767906449166439/019d02ca-a9aa-73d9-bd7a-a5bbb80ff37e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOZ3qgdHh1YYRZvCqCq1Of3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sportswear_store"
    },
    {
      "id": "custom_09cf7f5a-7a18-48cb-9739-c4e1a6f5939e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Wild Burro Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14810 N Secret Springs Dr, Marana, AZ 85658, USA",
      "poi_short_description": "Saguaro-studded hiking area with paths for all skill levels, plus bike trails.",
      "poi_long_description": "Visitors say this trail offers many options for length and difficulty, with some paths being flat and sandy, while others are rocky with uphill sections. They also highlight the beautiful scenery and vistas, recommending hiking boots for ankle support on more challenging routes. Others mention it's a great starting point for hiking and biking, and that dogs enjoy the trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b916-74dc-8e68-f2cfefe973ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b916-74dc-8e68-f2cfefe973ea",
        "storage_key": "property/6767906449166439/019f0b0a-b916-74dc-8e68-f2cfefe973ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maranaaz.gov/trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592144538172591191&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wild-burro-trailhead",
      "poi_latitude": "32.4754271",
      "poi_longitude": "-111.0910608",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-382-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZcYBycI1oYRVwxrOtRJm00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_24db93f1-13ed-424e-8b54-5f25789557f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Tortolita Preserve Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6250 W Moore Rd, Marana, AZ 85658, USA",
      "poi_short_description": "Desert preserve featuring a 9.5-mile loop for mountain biking and hiking with scenic views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b53a-760f-8d85-dc03677c9888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b53a-760f-8d85-dc03677c9888",
        "storage_key": "property/6767906449166439/019f0b0a-b53a-760f-8d85-dc03677c9888.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maranaaz.gov/trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=7589566277038493319&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tortolita-preserve-trailhead",
      "poi_latitude": "32.4391566",
      "poi_longitude": "-111.0983017",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-add7-708c-8a6e-e4104f34f9f9",
        "storage_key": "property/6767906449166439/019d02ca-add7-708c-8a6e-e4104f34f9f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8jVynTi1YYRh84pVlGOU2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_675a3f6b-151b-4178-aea4-93b363abc355",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Dove Mountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5401-5499 W Dove Mountain Park Rd, Marana, AZ 85658, USA",
      "poi_short_description": "Well-kept, shady park featuring slides, swings and a playground, plus basketball and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b12e-72bb-8e36-98b735d5bedf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b12e-72bb-8e36-98b735d5bedf",
        "storage_key": "property/6767906449166439/019f0b0a-b12e-72bb-8e36-98b735d5bedf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15093592930893757683&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-mountain-park",
      "poi_latitude": "32.4340284",
      "poi_longitude": "-111.0818591",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae51-715c-9ae7-726b1952fe65",
        "storage_key": "property/6767906449166439/019d02ca-ae51-715c-9ae7-726b1952fe65.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2OQgOUJ1oYR8_xEJs02d9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b77cbef1-f656-481b-92c4-18aa07ea68e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Mountain Rose Academy - Charter School",
      "poi_type": "Education",
      "poi_address": "3686 W Orange Grove Rd #180, Tucson, AZ 85741, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b8c9-729a-ab7d-f139ee120b08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b8c9-729a-ab7d-f139ee120b08",
        "storage_key": "property/6767906449166439/019f0b0a-b8c9-729a-ab7d-f139ee120b08.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.go2rose.com/schools/mountain-rose-academy?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=mountain-rose",
      "poi_directions_map_url": "https://maps.google.com/?cid=11572195550091890921&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-rose-academy---charter-school",
      "poi_latitude": "32.3247432",
      "poi_longitude": "-111.0435154",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-797-4884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU5HZ09h01oYR6VCVaoqymKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_31ea4957-7f6e-45c6-9ff3-1ae48af34a53",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Tucson International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7250 S Tucson Blvd, Tucson, AZ 85756, USA",
      "poi_short_description": "Airport serving southern Arizona & featuring free WiFi plus exhibits by regional artists.",
      "poi_long_description": "People say this airport offers convenient access to rental cars and gates, and has a cell phone free parking lot. They highlight the easy navigation, short lines, and friendly, helpful staff. They also like the clean spaces and nice artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b11e-73b4-bf69-542152be6314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b11e-73b4-bf69-542152be6314",
        "storage_key": "property/6767906449166439/019f0b0a-b11e-73b4-bf69-542152be6314.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flytucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12911939063544620565&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-international-airport",
      "poi_latitude": "32.1145102",
      "poi_longitude": "-110.9392269",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-573-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-b206-71a5-8794-893ad27c3480.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-b206-71a5-8794-893ad27c3480",
        "storage_key": "property/6767906449166439/019d02ca-b206-71a5-8794-893ad27c3480.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9XQCBN71oYRFSYR_CpsMLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_1fc8177f-aa2d-4578-b093-40d4b73ea00e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Thornydale Rd & Cortaro Farms Rd Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Thornydale Rd & W Cortaro Farms Rd, Tucson, AZ 85742",
      "poi_short_description": "Sun Tran 412, 413, and Sun Shuttle connections",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e7c296c8-ed68-4794-b293-c681d733f4ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Ina Rd & Thornydale Rd. Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Thornydale Rd & W Ina Rd, Tucson, AZ 85741",
      "poi_short_description": "Routes: 62, 102X, 103X, 413",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4da74af1-a9bc-46c3-933f-e6774c8e5078",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Ina Rd. & Oldfather Rd Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Ina Rd & N Oldfather Rd, Marana, AZ 85741",
      "poi_short_description": "Routes: 62, 102X, 103X, 413",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03a61ef0-3427-457c-bddf-85990dca3f31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Sun Shuttle",
      "poi_type": "Transportation & Transit",
      "poi_address": "3920 N Sun Tran Blvd Tucson, AZ 85705",
      "poi_short_description": "On-demand + fixed shuttle service",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2273f76f-3460-404d-a5d0-53722b674ff9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Marana Crossroads Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "8150 N Cortaro Rd, Tucson, AZ 85743",
      "poi_short_description": "Routes: 104X, 204X express routes",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5fc598c3-98da-499f-938f-9f46deb1920a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Caterpillar",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Oracle Rd, Tucson, AZ 85704",
      "poi_short_description": "One of the largest industrial employers in the region; many engineering + technician roles",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a56dae6f-9aca-4a82-b157-76f905169da2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Oro Valley Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1551 E Tangerine Rd, Oro Valley, AZ 85755, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b295-71d6-9207-8ac97e27d39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b295-71d6-9207-8ac97e27d39a",
        "storage_key": "property/6767906449166439/019f0b0a-b295-71d6-9207-8ac97e27d39a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.healthiertucson.com/oro-valley-hospital?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=378322275733317383&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oro-valley-hospital",
      "poi_latitude": "32.4291928",
      "poi_longitude": "-110.9485214",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-901-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae3e-75e8-88fa-ca84bd8f03d4",
        "storage_key": "property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUZ16MwN1oYRB6ez9xoSQAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_19e8cded-0d52-4085-9f79-3b77beec32be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Northwest Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6200 N La Cholla Blvd, Tucson, AZ 85741, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019f0b0a-b4cd-7550-858e-251dcf90c347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0b0a-b4cd-7550-858e-251dcf90c347",
        "storage_key": "property/6767906449166439/019f0b0a-b4cd-7550-858e-251dcf90c347.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "https://www.healthiertucson.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14865435973531345650&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwest-medical-center",
      "poi_latitude": "32.3195928",
      "poi_longitude": "-111.0094542",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-742-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-ae3e-75e8-88fa-ca84bd8f03d4",
        "storage_key": "property/6767906449166439/019d02ca-ae3e-75e8-88fa-ca84bd8f03d4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs6P52Zl01oYR8iKm6UGjTM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2559b79c-276d-4280-b2be-60204431b0a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Amphitheater Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 W Wetmore Rd, Tucson, AZ 85705, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.amphi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12000191683805237204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amphitheater-public-schools",
      "poi_latitude": "32.2857867",
      "poi_longitude": "-110.9819579",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-696-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-a9af-722d-a0c4-2ded0d39e86d",
        "storage_key": "property/6767906449166439/019d02ca-a9af-722d-a0c4-2ded0d39e86d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFa4kL5Nz1oYR1M_OtcE-iaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18e26157-e60e-40d2-acdf-5926180c32e5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "poi_name": "Marana Unified School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11279 W Grier Rd, Marana, AZ 85653",
      "poi_short_description": "Major source of teaching, admin, and support jobs",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_8aaff0c2-ea94-467c-8c34-0b9de5da25d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1c818474-e744-4530-aa5f-7609406ab1a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_dd6722c5-b4bf-47ca-a930-2769c6cc7da8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1b53173c-c2c6-480e-882e-5449b2285484",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aeca6094-6938-476c-b258-6e7543b5932c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a195d734-0705-4c4c-a477-aae7861a79f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ef5c3002-d26b-472d-ad39-c576bf00f9cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "rating": "5.0",
      "name": "Michelle Farenga",
      "text": "Jem was was wonderful! She spent time with us and helped us make a great decision. We are so happy and excited! The Legacy at Dove Mountain is a nice small complex that is a little set back so it feels quiet and peaceful. Nicely laid out floor plans and extra services I never even knew existed. Very lovely place to be.",
      "date": "2025-04-26",
      "title": ""
    },
    {
      "id": "custom_459b32fc-58d4-4831-83b6-887f6575876d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "rating": "5.0",
      "name": "Corey Miller",
      "text": "Great property and staff. Maintenance was excellent as well, props to the hard working gentlemen that helped out during my time here. Ladies at the front office were always helpful and pleasant. Very quiet area but not much around, so keep that in mind if you want close shopping and nightlife. Internet was very fast and reliable (which is very important to me at least). Would have continued to live here but needed to move closer to Tucson for work.",
      "date": "2025-04-21",
      "title": ""
    },
    {
      "id": "custom_da2ae262-f772-4ef5-a275-eae748e502ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "rating": "5.0",
      "name": "Karen Nelson",
      "text": "Jem was amazing! She helped me from beginning to end! She answered all my questions and took the time to explain how things were processed and how to get services started at my apartment!  Couldn’t have done it without her!",
      "date": "2025-07-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8c0ba2eb-bc5e-4d5d-a8c8-6ef3b1697d36",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cb-1398-7727-95cd-566ddd02b271.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lounge area with shuffleboard, comfortable seating, and fireplace.",
        "public_id": "019d02cb-1398-7727-95cd-566ddd02b271",
        "storage_key": "property/6767906449166439/019d02cb-1398-7727-95cd-566ddd02b271.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XDBeFLBF1ve"
    },
    {
      "id": "custom_f51f820c-c361-4ec2-875b-0b864ed7b28c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cb-13ae-713d-a9e1-153d55e2eca5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with a white sofa, marble coffee table, and decorative wall art.",
        "public_id": "019d02cb-13ae-713d-a9e1-153d55e2eca5",
        "storage_key": "property/6767906449166439/019d02cb-13ae-713d-a9e1-153d55e2eca5.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 975 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FiTDfin62KB"
    },
    {
      "id": "custom_6296b5cd-82a6-417a-96c5-3e4d78a03aea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cb-13cc-7724-b570-25485ec05af9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019d02cb-13cc-7724-b570-25485ec05af9",
        "storage_key": "property/6767906449166439/019d02cb-13cc-7724-b570-25485ec05af9.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Community Tour | Poolside Oasis",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iGLZW7tzhL6"
    },
    {
      "id": "custom_63de3d6e-01b4-4d03-98dc-56f7d77144c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cb-c9f4-71ac-a2a7-593db2fb578f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Package lockers in a multifamily property.",
        "public_id": "019d02cb-c9f4-71ac-a2a7-593db2fb578f",
        "storage_key": "property/6767906449166439/019d02cb-c9f4-71ac-a2a7-593db2fb578f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Amazon Lockers",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VussQ8Ph9eY"
    },
    {
      "id": "custom_3fee798b-67ab-4278-b0eb-8cf7e1f8c4d5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166439/019d02cb-25b2-762d-9a95-8be321df77c3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
        "public_id": "019d02cb-25b2-762d-9a95-8be321df77c3",
        "storage_key": "property/6767906449166439/019d02cb-25b2-762d-9a95-8be321df77c3.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eZWTy395yvb"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfd9-8c3b-76cc-8c56-160948245d63",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-legacy-apartments-at-dove-mountain-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-marana-az",
      "search_query": "apartments with in unit laundry Marana AZ",
      "category": "Amenity",
      "h1_title": "Apartments with In Unit Laundry in Marana, AZ",
      "h2_subtitle": "Enjoy the convenience of apartments with in unit laundry at Legacy Apartments in Marana, AZ. Experience unparalleled comfort and modern amenities here.",
      "page_copy": "Legacy Apartments at Dove Mountain offers modern living in Marana, AZ, featuring units with in unit laundry facilities. Imagine never having to leave your apartment for laundry chores again! Our community is designed for convenience and style, with ceramic style flooring, plush carpeting, and expertly crafted details throughout.\n\nAside from having in unit laundry, residents can unwind in our resort-style heated swimming pool or relax at our spa with seating. Enjoy the convenience of Amazon HUB Lockers and socialize in our welcoming clubhouse. Discover a perfect blend of comfort and practicality at Legacy Apartments at Dove Mountain, where every detail has been thoughtfully curated for your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In Unit Laundry Marana, AZ",
      "seo_description": "Discover Marana's Legacy Apartments with in unit laundry. Enjoy modern amenities and a prime location at Dove Mountain. Rent today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-pima-county",
      "search_query": "luxury apartments with pool in Pima County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Pima County",
      "h2_subtitle": "Discover luxury apartments with a pool in Pima County at Legacy Apartments. Experience upscale living with impressive amenities and comfort.",
      "page_copy": "Legacy Apartments at Dove Mountain is your destination for luxury apartments with a pool in Pima County. Our community provides an oasis with a resort-style heated swimming pool, perfect for relaxation and recreation alike. Discover the elevated lifestyle that awaits you here.\n\nBeyond the stunning pool, our luxury amenities include a relaxing spa with seating and a stylish clubhouse ideal for gatherings. Inside your apartment, enjoy details like ceramic style flooring, plush carpeting, and modern conveniences such as Amazon HUB Lockers. Choose Legacy Apartments at Dove Mountain for a remarkable living experience, where luxury meets comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Pima County",
      "seo_description": "Live in Pima County's luxury apartments with a pool at Legacy. Enjoy upscale amenities and a premier location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-bark-park-marana",
      "search_query": "dog-friendly apartments with bark park in Marana",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Bark Park in Marana",
      "h2_subtitle": "Explore dog-friendly apartments with a bark park at Legacy Apartments in Marana. Perfect for pet owners seeking a community that welcomes furry friends.",
      "page_copy": "At Legacy Apartments at Dove Mountain, we understand that pets are family. That's why our dog-friendly apartments in Marana come complete with a bark park, tailored for your canine companions. Let your dogs run free and socialize in a safe, welcoming environment.\n\nBeyond our pet-friendly amenities, residents can relax in our resort-style heated swimming pool and enjoy our well-appointed clubhouse. Experience modern living with ceramic style flooring and plush carpeting, and take advantage of convenient features like Amazon HUB Lockers. Make Legacy Apartments at Dove Mountain your next home where both you and your pets can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Bark Park Marana",
      "seo_description": "Find dog-friendly apartments with a bark park in Marana at Legacy. Perfect for you and your pets. Discover more today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-85658",
      "search_query": "fitness center apartments near 85658",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 85658",
      "h2_subtitle": "Find apartments with a fitness center near 85658 at Legacy Apartments. Discover a community focused on your health and well-being.",
      "page_copy": "Legacy Apartments at Dove Mountain offers ideal apartments near the 85658 area, featuring a fully equipped fitness center. Enjoy the convenience of staying fit just steps from your front door. With modern equipment and a space dedicated to your wellness, achieving your fitness goals has never been easier.\n\nAlongside our fitness center, residents can relax in our resort-style heated swimming pool or unwind in the spa with seating. Our community also includes a stylish clubhouse, ceramic style flooring, plush carpeting, and practical amenities like Amazon HUB Lockers. Experience a well-rounded lifestyle at Legacy Apartments at Dove Mountain, where health meets home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near 85658",
      "seo_description": "Explore fitness center apartments near the 85658 area at Legacy Apartments. Enjoy modern amenities and a convenient location. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "apartments-with-garages-dove-mountain",
      "search_query": "apartments with garages in Dove Mountain",
      "category": "Amenity",
      "h1_title": "Apartments with Garages in Dove Mountain",
      "h2_subtitle": "Discover premium apartments with garages in Dove Mountain at Legacy Apartments. Enjoy ultimate convenience and security for your vehicle.",
      "page_copy": "Legacy Apartments at Dove Mountain offers the perfect combination of modern living and convenience with our apartments featuring garages. Located in the beautiful Dove Mountain area, having a garage provides added security and ease for your vehicle, making every day simpler.\n\nIn addition to these practical features, residents can enjoy a variety of amenities including a resort-style heated swimming pool, a relaxing spa with seating, and a supportive community atmosphere. The apartments feature sleek ceramic style flooring and plush carpeting, plus modern conveniences like Amazon HUB Lockers. Live a comprehensive lifestyle where comfort blends with convenience at Legacy Apartments at Dove Mountain.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Garages in Dove Mountain",
      "seo_description": "Find apartments with garages in Dove Mountain at Legacy Apartments. Enjoy secure and convenient living with modern amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-dove-mountain",
      "search_query": "one bedroom apartments near Dove Mountain",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Dove Mountain",
      "h2_subtitle": "Explore spacious one bedroom apartments near Dove Mountain at Legacy Apartments. Perfect for comfortable and stylish living in Marana.",
      "page_copy": "Legacy Apartments at Dove Mountain offers an ideal selection of one bedroom apartments near Dove Mountain, providing a perfect blend of style and comfort. Enjoy spacious floor plans designed with ceramic style flooring and plush carpeting, tailored to suit your lifestyle.\n\nResidents at Legacy Apartments have access to a wide array of amenities, including a resort-style heated swimming pool and a relaxing spa with seating. The community features conveniences like an on-site clubhouse and Amazon HUB Lockers, facilitating a comfortable and modern living environment. Experience the tranquility and luxury of living near Dove Mountain at Legacy Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Dove Mountain",
      "seo_description": "Find spacious one bedroom apartments near Dove Mountain at Legacy. Enjoy modern amenities and a convenient location in Marana. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-marana-az",
      "search_query": "two bedroom apartments Marana AZ",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Marana, AZ",
      "h2_subtitle": "Discover spacious two bedroom apartments in Marana, AZ at Legacy Apartments. Perfect for families or roommates seeking style and comfort.",
      "page_copy": "Legacy Apartments at Dove Mountain offers the ultimate in two bedroom apartments in Marana, AZ, providing ample space and modern design. These residences are perfect for families or roommates who desire personal space along with shared living areas, all complemented by ceramic style flooring and plush carpeting.\n\nLiving at Legacy Apartments means enjoying amenities like a resort-style heated swimming pool, a relaxing spa with seating, and a vibrant clubhouse. Practical services such as Amazon HUB Lockers are available to simplify daily life. Discover the benefits of community living while maintaining your private sanctuary in our exquisite two bedroom homes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Marana, AZ",
      "seo_description": "Find ideal two bedroom apartments in Marana, AZ at Legacy Apartments. Enjoy spacious living with modern amenities. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-pima-county",
      "search_query": "three bedroom apartments in Pima County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Pima County",
      "h2_subtitle": "Explore luxurious three bedroom apartments in Pima County at Legacy Apartments. Ideal for larger families or those seeking extra space.",
      "page_copy": "Legacy Apartments at Dove Mountain offers spectacular three bedroom apartments in Pima County, providing plenty of room for larger families or individuals craving additional space. Our thoughtfully designed layouts incorporate ceramic style flooring and plush carpeting, ensuring both comfort and style.\n\nResidents at Legacy benefit from engaging community amenities like a resort-style heated swimming pool and a calming spa with seating. Live surrounded by convenience with Amazon HUB Lockers on site and a welcoming clubhouse to meet neighbors. Experience upscale living with all the modern comforts in the heart of Pima County at Legacy Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Pima County",
      "seo_description": "Find spacious three bedroom apartments in Pima County at Legacy. Experience luxurious living with modern amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "apartments-near-carondelet-marana-emergency-center",
      "search_query": "apartments near Carondelet Marana Emergency Center AZ",
      "category": "Hospital",
      "h1_title": "Apartments Near Carondelet Marana Emergency",
      "h2_subtitle": "Looking for apartments near Carondelet Marana Emergency Center, AZ? Legacy Apartments offers convenient and comfortable living in Marana.",
      "page_copy": "Legacy Apartments at Dove Mountain presents ideal living options for those seeking apartments near Carondelet Marana Emergency Center, AZ. Positioned in a prime location, our community ensures quick access to essential services while providing a peaceful retreat from the bustling city life.\n\nResidents can enjoy an array of amenities that promote a balanced lifestyle, such as a resort-style heated swimming pool and a relaxing spa with seating. Modern conveniences like Amazon HUB Lockers and a well-equipped clubhouse further enhance the living experience, making Legacy Apartments a perfect choice for those in search of comfort and convenience near Carondelet Marana Emergency Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carondelet Marana Emergency",
      "seo_description": "Discover convenient apartments near Carondelet Marana Emergency Center at Legacy. Enjoy modern amenities and a prime location in Marana, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "apartments-near-naranja-park-marana",
      "search_query": "apartments near naranja park marana",
      "category": "Park",
      "h1_title": "Apartments Near Naranja Park, Marana",
      "h2_subtitle": "Discover apartments near Naranja Park in Marana at Legacy Apartments, offering ideal access to outdoor activities and community amenities.",
      "page_copy": "Legacy Apartments at Dove Mountain provides outstanding living options for those seeking apartments near Naranja Park, Marana. This location is perfect for outdoor enthusiasts who love being close to recreational activities while enjoying the modern comforts of home.\n\nResidents of Legacy Apartments benefit from exceptional amenities, including a resort-style heated swimming pool and a soothing spa with seating. The vibrant clubhouse provides a perfect setting for socializing and events, while Amazon HUB Lockers offer added convenience. Enjoy proximity to Naranja Park and all it offers when you live in our welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Naranja Park, Marana",
      "seo_description": "Find ideal apartments near Naranja Park, Marana at Legacy Apartments. Enjoy modern amenities and outdoor adventure just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166439",
      "source": "generator",
      "page_item_url": "marana-az-apartments-near-silverbell-district-park",
      "search_query": "marana az apartments close to crossroads at silverbell district park",
      "category": "Park",
      "h1_title": "Marana AZ Apartments by Silverbell Park",
      "h2_subtitle": "Live near Crossroads at Silverbell District Park in Marana, AZ. Discover spacious living at Legacy Apartments and enjoy nearby amenities.",
      "page_copy": "Legacy Apartments at Dove Mountain offers prime Marana, AZ apartments close to Crossroads at Silverbell District Park. This locale is ideal for residents seeking close proximity to recreational activities and vibrant community events while enjoying a serene living environment.\n\nOur community boasts stylish interiors featuring ceramic style flooring and plush carpeting, creating an inviting atmosphere. Take advantage of relaxing amenities, including a heated swimming pool and a spa designed with ample seating. With the convenience of Amazon HUB Lockers and a welcoming clubhouse, Legacy Apartments provide everything you need in a prime location near Silverbell District Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Marana AZ Apartments by Silverbell Park",
      "seo_description": "Discover Marana AZ apartments near Silverbell District Park at Legacy. Experience modern living with top-notch community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5309"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425672"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=a57ddc15eb69d79b503b53f6df3f935d19600b484e70c221dc6f2348a4cdc20ff85cbd43e9159ed062b4921cb2649a0d\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P8WMKKRM"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "241LDM"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40239852128"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Legacy Apartments at Dove Mountain/scheduletourwidget/FrVCUOcuogWOIdMDk1/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im9ZdG42SlpLT2tYY1pLSFFVb3NlS3c9PSIsInZhbHVlIjoiWStIOWlZUmdkeVk0VU9IMitIOHNJUT09IiwibWFjIjoiMDEwMDYzZjhiZmY1MzdjOWI4Njg5NzczNmQwOWRhMWFkNDlmODg1NzYxMDA4ZjY3Y2NmY2JhYTA0Mzc3N2JiMiJ9"
    }
  ],
  "custom_qb_id": "5309",
  "custom_repli_id": "18104425672",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=a57ddc15eb69d79b503b53f6df3f935d19600b484e70c221dc6f2348a4cdc20ff85cbd43e9159ed062b4921cb2649a0d\"></script>",
  "custom_google_gtm_id": "GTM-P8WMKKRM",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "241LDM",
  "custom_hubspot_company_id": "40239852128",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Legacy Apartments at Dove Mountain/scheduletourwidget/FrVCUOcuogWOIdMDk1/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im9ZdG42SlpLT2tYY1pLSFFVb3NlS3c9PSIsInZhbHVlIjoiWStIOWlZUmdkeVk0VU9IMitIOHNJUT09IiwibWFjIjoiMDEwMDYzZjhiZmY1MzdjOWI4Njg5NzczNmQwOWRhMWFkNDlmODg1NzYxMDA4ZjY3Y2NmY2JhYTA0Mzc3N2JiMiJ9",
  "custom_audioeye_site_id": "da95d4f9-2126-45bd-bed2-08593a441728",
  "custom_audioeye_site_hash": "c885e1f0ebb24f231d125ca3844ccadf"
};

export const generatedAt = '2026-08-24T16:58:39.262Z';
